// Wording and lists for the admin Automation page (hashh-api-v2 /automation
// settings).

// The automation types the API switches one by one, in its order.
export const AUTOMATION_TYPES = [
  { key: "tap", label: "Tap to run" },
  { key: "schedule", label: "Schedules" },
  { key: "timer", label: "Timers" },
  { key: "sun", label: "Sunrise and sunset" },
  { key: "rule", label: "Rules" },
  { key: "location", label: "Location" },
  { key: "inching", label: "Inching" },
  { key: "cycling", label: "Cycling" },
  { key: "nfc", label: "NFC tags" },
];

// The types the old routines, scenes and rules moved into. Their old system
// was retired on 14 Oct 2026 (hashh-api-v2 f0f593c), so the API keeps them on
// New, and Automation on for every home.
export const RETIRED_SYSTEM_TYPES = ["tap", "schedule", "sun", "rule"];

// Who runs a type. The other types never had an old system, so Legacy only
// means the new engine leaves them alone.
export const MODES = [
  { key: "legacy", label: "Legacy", help: "The new engine leaves it alone, and the app doesn't offer it." },
  { key: "shadow", label: "Shadow", help: "The new engine works out each run and records it, but switches nothing." },
  { key: "new", label: "New", help: "The new engine runs it." },
];

export const modeLabel = (key) => MODES.find((mode) => mode.key === key)?.label ?? key;

export const typeLabel = (key) => AUTOMATION_TYPES.find((type) => type.key === key)?.label ?? key;

// The types the settings have, in the order above. A type the API adds later
// still shows, under its key, until it gets a name here.
export const typesIn = (types = {}) => [
  ...AUTOMATION_TYPES.filter(({ key }) => key in types),
  ...Object.keys(types)
    .filter((key) => !AUTOMATION_TYPES.some((type) => type.key === key))
    .map((key) => ({ key, label: key })),
];

// "A and B", "A, B, and C": the last comma keeps names with "and" in them apart.
export const listText = (items) =>
  items.length > 1
    ? `${items.slice(0, -1).join(", ")}${items.length > 2 ? "," : ""} and ${items[items.length - 1]}`
    : items.join("");

// A home id as the API takes it: 24 hex characters.
export const HOME_ID = /^[a-f0-9]{24}$/i;
